var _path, _g, _path2, _g2, _path3, _path4, _g3, _g4, _g5, _g6, _path5, _g7, _g8, _g9, _g10, _path6, _g11, _g12, _g13, _g14, _path7, _g15, _g16, _g17, _g18, _path8, _g19, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChromeWebStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 148 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 38,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0v29.74a2.583 2.583 0 0 0 2.56 2.56h32.301a2.583 2.583 0 0 0 2.56-2.56V0H0Zm22.93 6.81h-8.497a1.689 1.689 0 0 1 0-3.376h8.497a1.689 1.689 0 0 1 0 3.375Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h37.422v32.3H0V0Z",
    fill: "#EEEDEE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 38,
    height: 33
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0v29.74a2.583 2.583 0 0 0 2.56 2.56h32.301a2.583 2.583 0 0 0 2.56-2.56V0H0Zm22.93 6.81h-8.497a1.689 1.689 0 0 1 0-3.376h8.497a1.689 1.689 0 0 1 0 3.375Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.93 3.434h-8.497a1.689 1.689 0 0 0 0 3.375h8.497a1.689 1.689 0 0 0 0-3.375Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 38,
    height: 33
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0v29.74a2.583 2.583 0 0 0 2.56 2.56h32.301a2.583 2.583 0 0 0 2.56-2.56V0H0Zm22.93 6.81h-8.497a1.689 1.689 0 0 1 0-3.376h8.497a1.689 1.689 0 0 1 0 3.375Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "g",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 13,
    width: 33,
    height: 33
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 13,
    width: 33,
    height: 33
  }, /*#__PURE__*/React.createElement("mask", {
    id: "e",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 13,
    width: 33,
    height: 33
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 13,
    width: 33,
    height: 33
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.851 30.94c.634-8.914-6.078-16.653-14.991-17.286-8.913-.634-16.652 6.078-17.286 14.991-.633 8.913 6.079 16.652 14.992 17.286 8.913.633 16.652-6.079 17.285-14.992Z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.851 30.94c.634-8.914-6.078-16.653-14.991-17.286-8.913-.634-16.652 6.078-17.286 14.991-.633 8.913 6.079 16.652 14.992 17.286 8.913.633 16.652-6.079 17.285-14.992Z",
    fill: "#fff"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.851 30.94c.634-8.914-6.078-16.653-14.991-17.286-8.913-.634-16.652 6.078-17.286 14.991-.633 8.913 6.079 16.652 14.992 17.286 8.913.633 16.652-6.079 17.285-14.992Z",
    fill: "#fff"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.851 30.94c.634-8.914-6.078-16.653-14.991-17.286-8.913-.634-16.652 6.078-17.286 14.991-.633 8.913 6.079 16.652 14.992 17.286 8.913.633 16.652-6.079 17.285-14.992Z",
    fill: "#fff"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.122 13.618v19.846h7.216l6.344-11h16.18v-8.787H5.121v-.059Zm0 0v19.846h7.216l6.344-11h16.18v-8.787H5.121v-.059Z",
    fill: "#DC4637"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "k",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 13,
    width: 33,
    height: 33
  }, /*#__PURE__*/React.createElement("mask", {
    id: "j",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 13,
    width: 33,
    height: 33
  }, /*#__PURE__*/React.createElement("mask", {
    id: "i",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 13,
    width: 33,
    height: 33
  }, /*#__PURE__*/React.createElement("mask", {
    id: "h",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 13,
    width: 33,
    height: 33
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.851 30.94c.634-8.914-6.078-16.653-14.991-17.286-8.913-.634-16.652 6.078-17.286 14.991-.633 8.913 6.079 16.652 14.992 17.286 8.913.633 16.652-6.079 17.285-14.992Z",
    fill: "#fff"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.851 30.94c.634-8.914-6.078-16.653-14.991-17.286-8.913-.634-16.652 6.078-17.286 14.991-.633 8.913 6.079 16.652 14.992 17.286 8.913.633 16.652-6.079 17.285-14.992Z",
    fill: "#fff"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.851 30.94c.634-8.914-6.078-16.653-14.991-17.286-8.913-.634-16.652 6.078-17.286 14.991-.633 8.913 6.079 16.652 14.992 17.286 8.913.633 16.652-6.079 17.285-14.992Z",
    fill: "#fff"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.851 30.94c.634-8.914-6.078-16.653-14.991-17.286-8.913-.634-16.652 6.078-17.286 14.991-.633 8.913 6.079 16.652 14.992 17.286 8.913.633 16.652-6.079 17.285-14.992Z",
    fill: "#fff"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.56 45.919h15.365l7.1-7.1v-5.355H12.339l-9.777-16.82V45.92Zm0 0h15.365l7.1-7.1v-5.355H12.339l-9.777-16.82V45.92Z",
    fill: "#0F9D58"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "o",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 13,
    width: 33,
    height: 33
  }, /*#__PURE__*/React.createElement("mask", {
    id: "n",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 13,
    width: 33,
    height: 33
  }, /*#__PURE__*/React.createElement("mask", {
    id: "m",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 13,
    width: 33,
    height: 33
  }, /*#__PURE__*/React.createElement("mask", {
    id: "l",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 13,
    width: 33,
    height: 33
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.851 30.94c.634-8.914-6.078-16.653-14.991-17.286-8.913-.634-16.652 6.078-17.286 14.991-.633 8.913 6.079 16.652 14.992 17.286 8.913.633 16.652-6.079 17.285-14.992Z",
    fill: "#fff"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#l)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.851 30.94c.634-8.914-6.078-16.653-14.991-17.286-8.913-.634-16.652 6.078-17.286 14.991-.633 8.913 6.079 16.652 14.992 17.286 8.913.633 16.652-6.079 17.285-14.992Z",
    fill: "#fff"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.851 30.94c.634-8.914-6.078-16.653-14.991-17.286-8.913-.634-16.652 6.078-17.286 14.991-.633 8.913 6.079 16.652 14.992 17.286 8.913.633 16.652-6.079 17.285-14.992Z",
    fill: "#fff"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.851 30.94c.634-8.914-6.078-16.653-14.991-17.286-8.913-.634-16.652 6.078-17.286 14.991-.633 8.913 6.079 16.652 14.992 17.286 8.913.633 16.652-6.079 17.285-14.992Z",
    fill: "#fff"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#o)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.682 22.465 6.344 11-7.159 12.454h16.936V22.407H18.682v.058Zm0 0 6.344 11-7.159 12.454h16.936V22.407H18.682v.058Z",
    fill: "#FFCE41"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "s",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 13,
    width: 33,
    height: 33
  }, /*#__PURE__*/React.createElement("mask", {
    id: "r",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 13,
    width: 33,
    height: 33
  }, /*#__PURE__*/React.createElement("mask", {
    id: "q",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 13,
    width: 33,
    height: 33
  }, /*#__PURE__*/React.createElement("mask", {
    id: "p",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 13,
    width: 33,
    height: 33
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.851 30.94c.634-8.914-6.078-16.653-14.991-17.286-8.913-.634-16.652 6.078-17.286 14.991-.633 8.913 6.079 16.652 14.992 17.286 8.913.633 16.652-6.079 17.285-14.992Z",
    fill: "#fff"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#p)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.851 30.94c.634-8.914-6.078-16.653-14.991-17.286-8.913-.634-16.652 6.078-17.286 14.991-.633 8.913 6.079 16.652 14.992 17.286 8.913.633 16.652-6.079 17.285-14.992Z",
    fill: "#fff"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#q)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.851 30.94c.634-8.914-6.078-16.653-14.991-17.286-8.913-.634-16.652 6.078-17.286 14.991-.633 8.913 6.079 16.652 14.992 17.286 8.913.633 16.652-6.079 17.285-14.992Z",
    fill: "#fff"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#r)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.851 30.94c.634-8.914-6.078-16.653-14.991-17.286-8.913-.634-16.652 6.078-17.286 14.991-.633 8.913 6.079 16.652 14.992 17.286 8.913.633 16.652-6.079 17.285-14.992Z",
    fill: "#fff"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#s)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.682 37.13a7.333 7.333 0 1 0 0-14.665 7.333 7.333 0 0 0 0 14.666Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.682 35.676a5.878 5.878 0 1 0 0-11.756 5.878 5.878 0 0 0 0 11.756Z",
    fill: "#557EBF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "t",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 38,
    height: 33
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0v29.74a2.583 2.583 0 0 0 2.56 2.56h32.301a2.583 2.583 0 0 0 2.56-2.56V0H0Zm22.93 6.81h-8.497a1.689 1.689 0 0 1 0-3.376h8.497a1.689 1.689 0 0 1 0 3.375Z",
    fill: "#fff"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h37.422v16.18H0V0Z",
    fill: "#212121",
    fillOpacity: 0.05
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.946h37.422v.233H0v-.233Z",
    fill: "#212121",
    fillOpacity: 0.02
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.18h37.422v.232H0v-.233Z",
    fill: "#fff",
    fillOpacity: 0.05
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.93 6.81h-8.497c-.873 0-1.63-.7-1.687-1.572v.116c0 .931.756 1.688 1.687 1.688h8.497c.932 0 1.688-.757 1.688-1.688v-.116a1.668 1.668 0 0 1-1.688 1.571ZM0 0v.233h37.422V0H0Z",
    fill: "#212121",
    fillOpacity: 0.02
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.433 3.434h8.497c.873 0 1.63.698 1.688 1.571V4.89c0-.931-.756-1.688-1.688-1.688h-8.497c-.93 0-1.687.757-1.687 1.688v.116a1.708 1.708 0 0 1 1.687-1.571Zm20.428 28.692h-32.3A2.583 2.583 0 0 1 0 29.566v.232a2.583 2.583 0 0 0 2.56 2.56h32.301a2.583 2.583 0 0 0 2.56-2.56v-.233a2.583 2.583 0 0 1-2.56 2.56Z",
    fill: "#231F20",
    fillOpacity: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0v29.74a2.583 2.583 0 0 0 2.56 2.56h32.301a2.583 2.583 0 0 0 2.56-2.56V0H0Zm22.93 6.81h-8.497a1.689 1.689 0 0 1 0-3.376h8.497a1.689 1.689 0 0 1 0 3.375Z",
    fill: "url(#u)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m46.152 12.484 2.56-6.81h.99l2.56 6.81h-.93l-.64-1.863H47.84l-.64 1.863h-1.048Zm1.979-2.62h2.27L49.293 6.78h-.058l-1.105 3.085ZM53.834 12.484l-1.862-4.656h.93l1.34 3.608 1.396-3.608h.931l-1.92 4.656h-.815ZM58.548 12.658c-.465 0-.931-.116-1.222-.407-.35-.291-.524-.64-.524-1.106 0-.524.175-.873.582-1.222.408-.291.873-.407 1.455-.407.524 0 .931.116 1.28.29V9.69c0-.349-.116-.64-.349-.815-.232-.232-.523-.29-.873-.29a1.55 1.55 0 0 0-.698.174.778.778 0 0 0-.407.466l-.815-.35c.116-.29.349-.523.64-.756.291-.233.757-.35 1.28-.35.582 0 1.106.175 1.455.524.408.35.582.815.582 1.455v2.794h-.814v-.64h-.059c-.29.465-.814.756-1.513.756Zm.175-.814c.349 0 .698-.117.99-.408.29-.29.465-.582.465-.931-.233-.233-.64-.291-1.106-.291-.407 0-.757.116-.99.291-.232.175-.349.407-.349.64 0 .233.117.408.291.524.233.116.466.175.699.175ZM62.913 6.664a.66.66 0 0 1-.465.174c-.175 0-.291-.058-.466-.174a.66.66 0 0 1-.175-.466c0-.174.058-.29.175-.465a.66.66 0 0 1 .465-.175c.175 0 .291.058.466.175a.66.66 0 0 1 .175.465.66.66 0 0 1-.175.466Zm0 5.82h-.873V7.828h.873v4.656ZM64.95 12.484h-.873V5.733h.873v6.75ZM67.394 12.658c-.465 0-.93-.116-1.222-.407-.349-.291-.523-.64-.523-1.106 0-.524.174-.873.581-1.222.408-.291.873-.407 1.455-.407.524 0 .932.116 1.28.29V9.69c0-.349-.116-.64-.348-.815-.233-.232-.524-.29-.873-.29a1.55 1.55 0 0 0-.699.174.778.778 0 0 0-.407.466l-.815-.35c.116-.29.35-.523.64-.756.291-.233.757-.35 1.28-.35.583 0 1.106.175 1.456.524.407.35.582.815.582 1.455v2.794h-.815v-.64h-.058c-.291.465-.815.756-1.514.756Zm.175-.814c.35 0 .698-.117.99-.408.29-.29.465-.582.465-.931-.233-.233-.64-.291-1.106-.291-.407 0-.756.116-.99.291-.232.175-.348.407-.348.64 0 .233.116.408.29.524.233.116.466.175.699.175ZM73.272 12.658c-.349 0-.698-.058-.93-.232a2.074 2.074 0 0 1-.64-.582h-.06v.64h-.814V5.733h.873v2.153l-.058.64h.058c.117-.233.35-.407.64-.582.291-.174.582-.233.931-.233.582 0 1.106.233 1.572.699.466.465.64 1.047.64 1.746 0 .698-.233 1.28-.64 1.746-.466.524-.99.756-1.572.756Zm-.116-.814c.407 0 .757-.175 1.048-.466.29-.291.465-.698.465-1.222s-.116-.931-.465-1.222c-.291-.291-.64-.466-1.048-.466-.407 0-.757.175-1.047.466-.291.29-.408.698-.408 1.222s.117.931.408 1.222c.232.35.582.466 1.047.466ZM77.114 12.484h-.873V5.733h.873v6.75ZM80.256 12.658c-.698 0-1.28-.232-1.687-.698-.466-.466-.64-1.048-.64-1.804 0-.699.232-1.28.64-1.746.407-.466.989-.757 1.63-.757.698 0 1.221.233 1.687.699.407.465.64 1.047.64 1.804v.174H78.86c0 .466.174.815.465 1.106.291.291.64.408.99.408.64 0 1.047-.291 1.28-.815l.757.349c-.175.35-.408.64-.757.931-.407.233-.873.35-1.339.35Zm1.223-3.026c0-.291-.117-.524-.35-.757-.232-.232-.582-.349-.989-.349-.35 0-.582.117-.815.291-.233.233-.407.466-.465.815h2.619ZM86.25 6.664a.66.66 0 0 1-.465.174c-.174 0-.29-.058-.465-.174a.66.66 0 0 1-.175-.466c0-.174.058-.29.175-.465a.66.66 0 0 1 .465-.175c.175 0 .291.058.466.175a.66.66 0 0 1 .174.465.66.66 0 0 1-.174.466Zm0 5.82h-.872V7.828h.873v4.656ZM88.23 7.828v.64h.058c.116-.233.349-.407.582-.582.29-.175.582-.233.873-.233.582 0 .99.175 1.338.524.291.35.466.815.466 1.455v2.852h-.873V9.748c0-.873-.407-1.28-1.164-1.28-.35 0-.64.116-.873.407a1.58 1.58 0 0 0-.35.99v2.56h-.872V7.77l.815.058ZM96.668 12.6c-.465 0-.873-.116-1.105-.407-.233-.233-.408-.64-.408-1.106V8.643h-.814v-.815h.814V6.373h.873v1.455h1.164v.815h-1.164v2.386c0 .524.233.756.64.756.175 0 .291 0 .408-.058l.29.757a2.17 2.17 0 0 1-.698.116ZM98.938 5.733v2.153l-.058.64h.058c.117-.233.35-.407.582-.582.291-.174.582-.233.873-.233.582 0 .99.175 1.339.524.291.35.465.815.465 1.455v2.852h-.873V9.807c0-.873-.407-1.28-1.164-1.28-.349 0-.64.116-.873.407a1.58 1.58 0 0 0-.349.989v2.56h-.873v-6.75h.873ZM105.34 12.658c-.698 0-1.28-.232-1.688-.698-.465-.466-.64-1.048-.64-1.804 0-.699.233-1.28.64-1.746.408-.466.99-.757 1.63-.757.698 0 1.222.233 1.688.699.407.465.64 1.047.64 1.804v.174h-3.667c0 .466.175.815.466 1.106.291.291.64.408.989.408.641 0 1.048-.291 1.281-.815l.756.349c-.174.35-.407.64-.756.931-.408.233-.873.35-1.339.35Zm1.222-3.026c0-.291-.116-.524-.349-.757-.233-.232-.582-.349-.989-.349-.349 0-.582.117-.815.291-.233.233-.407.466-.466.815h2.619ZM50.808 26.742c-1.339 0-2.445-.465-3.318-1.338-.873-.873-1.338-2.037-1.338-3.376 0-1.338.465-2.444 1.338-3.375.873-.873 1.98-1.339 3.318-1.339s2.444.466 3.317 1.455l-.815.757c-.64-.757-1.455-1.164-2.502-1.164-.99 0-1.804.349-2.503.99-.698.64-.99 1.512-.99 2.618 0 1.048.35 1.92.99 2.62.699.64 1.513.988 2.503.988 1.105 0 1.978-.465 2.793-1.28l.815.815a4.617 4.617 0 0 1-1.571 1.164c-.64.29-1.28.465-2.037.465ZM56.57 17.547v2.852l-.059.873h.058c.175-.291.408-.524.815-.757.35-.233.757-.29 1.164-.29.757 0 1.339.232 1.746.697.408.466.582 1.106.582 1.863v3.783h-1.164v-3.609c0-1.163-.524-1.687-1.513-1.687-.466 0-.873.174-1.164.582-.291.407-.466.815-.466 1.338v3.376h-1.164v-8.963l1.164-.058ZM63.379 26.51h-1.164v-6.17h1.105v.99h.059c.116-.35.349-.64.698-.815.35-.233.698-.35 1.048-.35.349 0 .64.06.873.175l-.466 1.106c-.175-.058-.35-.116-.64-.116-.407 0-.815.175-1.106.524-.35.349-.465.756-.465 1.28v3.376h.058ZM66.929 21.097c.582-.64 1.338-.931 2.27-.931.93 0 1.687.29 2.27.931.581.64.872 1.397.872 2.328 0 .931-.29 1.746-.873 2.328-.582.64-1.338.931-2.27.931-.93 0-1.687-.29-2.27-.931-.581-.64-.872-1.397-.872-2.328 0-.931.29-1.688.873-2.328Zm.873 3.958c.407.407.873.582 1.397.582.523 0 .989-.233 1.396-.582.408-.408.582-.932.582-1.63 0-.698-.174-1.222-.582-1.63a1.892 1.892 0 0 0-1.396-.582c-.524 0-.99.233-1.397.582-.408.408-.582.932-.582 1.63 0 .698.174 1.222.582 1.63ZM73.33 26.51v-6.17h1.106v.873h.059c.174-.29.465-.523.814-.756.35-.233.699-.291 1.106-.291.931 0 1.63.407 1.92 1.164.525-.757 1.223-1.164 2.154-1.164.757 0 1.28.233 1.63.698.349.466.582 1.106.582 1.863v3.783h-1.164V22.9c0-.64-.117-1.047-.35-1.338-.232-.233-.581-.408-1.047-.408-.466 0-.815.175-1.106.582-.29.408-.465.815-.465 1.339v3.375h-1.164v-3.608c0-.64-.117-1.047-.35-1.338-.232-.233-.582-.408-1.047-.408-.466 0-.815.175-1.106.582-.29.408-.466.815-.466 1.339v3.375l-1.105.117ZM86.775 26.742c-.931 0-1.688-.29-2.27-.93-.582-.641-.873-1.398-.873-2.329 0-.873.29-1.688.873-2.328.582-.64 1.28-.99 2.153-.99.931 0 1.63.292 2.212.874.524.582.815 1.397.815 2.386v.233h-4.89c.06.64.234 1.106.641 1.455.407.349.815.524 1.339.524.814 0 1.396-.35 1.687-1.048l1.048.407c-.175.466-.524.873-.99 1.223-.465.349-1.047.523-1.745.523Zm1.687-4.015c0-.35-.174-.699-.465-.99-.291-.349-.757-.465-1.339-.465-.407 0-.814.116-1.106.407-.29.291-.523.64-.64 1.106h3.55v-.058ZM103.652 17.547l-2.386 8.963h-1.164l-1.92-5.937h-.058l-1.921 5.937h-1.164l-2.503-8.963h1.223l1.92 7.1h.058l1.92-5.878h1.107l1.92 5.878h.058l1.805-7.1h1.105ZM106.679 26.742c-.931 0-1.688-.29-2.27-.93-.582-.641-.873-1.398-.873-2.329 0-.873.291-1.688.873-2.328.582-.64 1.28-.99 2.153-.99.932 0 1.63.292 2.212.874.524.582.815 1.397.815 2.386v.233H104.7c.058.64.233 1.106.64 1.455.408.349.815.524 1.339.524.815 0 1.396-.35 1.687-1.048l1.048.407c-.175.466-.524.873-.989 1.223a3.08 3.08 0 0 1-1.746.523Zm1.629-4.015c0-.35-.174-.699-.465-.99-.291-.349-.757-.465-1.339-.465-.407 0-.815.116-1.106.407-.291.291-.523.64-.64 1.106h3.55v-.058ZM113.837 26.742c-.465 0-.873-.116-1.28-.29a2.06 2.06 0 0 1-.815-.757h-.058v.873h-1.106v-8.963h1.164v2.852l-.058.873h.058a2.06 2.06 0 0 1 .815-.757 2.962 2.962 0 0 1 1.28-.29c.815 0 1.455.29 2.037.93.582.64.873 1.397.873 2.328 0 .932-.291 1.688-.873 2.328-.524.524-1.222.873-2.037.873Zm-.174-1.047c.523 0 .989-.233 1.396-.582.408-.407.582-.931.582-1.63 0-.698-.174-1.222-.582-1.63a1.89 1.89 0 0 0-1.396-.581c-.524 0-.99.174-1.397.582-.408.407-.582.93-.582 1.63 0 .698.174 1.221.582 1.629.407.35.873.582 1.397.582ZM122.974 26.742c-.64 0-1.28-.232-1.92-.64-.64-.407-1.048-1.047-1.222-1.804l1.047-.407c.117.465.408.93.757 1.222.349.29.815.524 1.338.524.524 0 .932-.117 1.281-.408.349-.29.524-.64.524-1.047 0-.524-.175-.873-.524-1.164-.349-.291-.931-.524-1.688-.757-.815-.233-1.397-.582-1.804-.99a2.11 2.11 0 0 1-.64-1.512c0-.64.232-1.223.756-1.688.524-.466 1.164-.699 1.979-.699.757 0 1.397.175 1.862.582.466.408.757.815.932 1.223l-1.048.465c-.058-.29-.233-.524-.582-.815-.291-.233-.698-.349-1.164-.349-.466 0-.815.116-1.106.35a1.214 1.214 0 0 0-.465.93c0 .35.116.64.407.873.291.233.698.466 1.28.64.466.117.815.292 1.106.408.291.116.582.291.873.524.291.233.524.524.699.815.174.349.232.698.232 1.164 0 .465-.116.814-.291 1.164-.174.349-.407.64-.698.814-.291.175-.64.35-.989.466a4.053 4.053 0 0 1-.932.116ZM129.551 26.626c-.64 0-1.106-.175-1.455-.524-.349-.349-.524-.814-.524-1.455v-3.2h-1.106v-1.048h1.106v-1.863h1.164V20.4h1.513v1.047h-1.513v3.143c0 .64.291.99.815.99.233 0 .407-.059.524-.117l.407.99a2.412 2.412 0 0 1-.931.174ZM131.762 21.097c.582-.64 1.339-.931 2.27-.931s1.688.29 2.27.931c.582.64.873 1.397.873 2.328 0 .931-.291 1.746-.873 2.328-.582.64-1.339.931-2.27.931s-1.688-.29-2.27-.931c-.581-.64-.872-1.397-.872-2.328 0-.931.291-1.688.872-2.328Zm.873 3.958c.408.407.873.582 1.397.582s.99-.233 1.397-.582c.407-.408.582-.932.582-1.63 0-.698-.175-1.222-.582-1.63a1.891 1.891 0 0 0-1.397-.582c-.524 0-.989.233-1.397.582-.407.408-.582.932-.582 1.63 0 .698.175 1.222.582 1.63ZM139.328 26.51h-1.164v-6.17h1.106v.99h.058c.117-.35.35-.64.699-.815.349-.233.698-.35 1.047-.35.35 0 .641.06.873.175l-.465 1.106c-.175-.058-.349-.116-.64-.116-.408 0-.815.175-1.106.524-.349.349-.466.756-.466 1.28v3.376h.058ZM145.09 26.742c-.931 0-1.688-.29-2.27-.93-.582-.641-.873-1.398-.873-2.329 0-.873.291-1.688.873-2.328.582-.64 1.281-.99 2.154-.99.931 0 1.629.292 2.211.874.524.582.815 1.397.815 2.386v.233h-4.889c.058.64.233 1.106.64 1.455.408.349.815.524 1.339.524.815 0 1.397-.35 1.688-1.048l1.047.407c-.174.466-.523.873-.989 1.223-.466.349-1.048.523-1.746.523Zm1.688-4.015c0-.35-.175-.699-.466-.99-.291-.349-.756-.465-1.338-.465-.408 0-.815.116-1.106.407a2.32 2.32 0 0 0-.64 1.106h3.55v-.058Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "u",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-.113 -.112) scale(48.3686)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromeWebStore);
export default __webpack_public_path__ + "static/media/chrome-web-store.f7af4ef5.svg";
export { ForwardRef as ReactComponent };